<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>
    {{
      'invite-signup-process-sms.component.verify_identity_header'
        | localise: 'Verify Identity'
    }}
  </h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

@if (inviteSignupProcessService.smsForm; as form) {
  <form [formGroup]="form" (ngSubmit)="next()">
    <mat-dialog-content>
      <p>
        {{
          'invite-signup-process-sms.component.sent_code_to'
            | localise: 'We sent a code to'
        }}
        {{ inviteSignupProcessService.phoneForm.controls.phoneNumber.value }}.
        {{
          'invite-signup-process-sms.component.confirm_identity_by_code'
            | localise
              : 'Please confirm your identity by entering the code we sent you.'
        }}
      </p>
      <mat-form-field class="full-width">
        <mat-label>{{
          'invite-signup-process-sms.component.verification_code'
            | localise: 'Verification Code'
        }}</mat-label>
        <input
          matInput
          type="tel"
          [maxLength]="5"
          formControlName="confirmationCode"
          appDisableAutofill />
      </mat-form-field>
      @switch (error) {
        @case ('Invalid Code') {
          {{
            'invite-signup-process-sms.component.wrong_code_error'
              | localise: 'You entered the wrong code from the SMS message'
          }}
        }
        @default {
          {{ error }}
        }
      }
    </mat-dialog-content>
    <div class="actions" mat-dialog-actions>
      <button
        mat-button
        type="button"
        (click)="inviteSignupProcessService.close.next()">
        {{
          'invite-signup-process-sms.component.close_button' | localise: 'Close'
        }}
      </button>
      <button
        type="submit"
        class="p-button p-button--rounded p-button--application-next"
        [disabled]="loading || form.invalid">
        {{
          'invite-signup-process-sms.component.continue_button'
            | localise: 'Continue'
        }}
      </button>
    </div>
  </form>
}
